var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 4.66667V10.6667C13.3333 11.4 12.7333 12 12 12H2.66667L0 14.6667V2.66667C0 1.93333 0.6 1.33333 1.33333 1.33333H8.06667C8 1.53333 8 1.8 8 2C8 2.2 8 2.46667 8.06667 2.66667H1.33333V10.6667H12V5.26667C12.4667 5.2 12.9333 4.93333 13.3333 4.66667ZM9.33333 2C9.33333 3.13333 10.2 4 11.3333 4C12.4667 4 13.3333 3.13333 13.3333 2C13.3333 0.866667 12.4667 0 11.3333 0C10.2 0 9.33333 0.866667 9.33333 2Z",
    fill: "#0065AA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.0dc173e21bd6b2be3c7ac048d3ace85b.svg";
export { ForwardRef as ReactComponent };